import { render, staticRenderFns } from "./financialCapacity.vue?vue&type=template&id=65b0253e&scoped=true&"
import script from "./financialCapacity.vue?vue&type=script&lang=js&"
export * from "./financialCapacity.vue?vue&type=script&lang=js&"
import style0 from "./financialCapacity.vue?vue&type=style&index=0&id=65b0253e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b0253e",
  null
  
)

export default component.exports